import gql from 'graphql-tag';

const GET_SERVICE_ORDERS = gql`
  query GetServiceOrders(
    $workspaceId: ID!
    $filter: ServiceOrderFilterInput
    $sort: ServiceOrderSortInput
    $skip: Int
    $take: Int
  ) {
    getServiceOrdersByWorkspaceId(
      workspaceId: $workspaceId
      filter: $filter
      sort: $sort
      skip: $skip
      take: $take
    ) {
      serviceOrders {
        id
        title
        description
        priority
        isFinished
        scheduledAt
        executedAt
        createdAt
        updatedAt
        statusId
        deviceId
        device {
          id
          name
          uniqueId
          workspacePrefix {
            prefix
          }
        }
        status {
          id
          description
        }
        leadTechnician {
          id
          firstName
          lastName
          profilePicture
        }
        technicians {
          id
          firstName
          lastName
          profilePicture
        }
        serviceOrderLogs {
          id
          serviceOrderId
          userId
          type
          comment
          createdAt
          updatedAt
          metaData
          attachments {
            fileName
            originalFilename
            fileType
            url
          }
        }
        serviceOrderTasks {
          id
          serviceOrderId
          description
          isCompleted
          createdAt
          updatedAt
        }
      }
      aggregate {
        rows
      }
    }
    getServiceOrderStatusesByWorkspaceId(workspaceId: $workspaceId) {
      id
      workspaceId
      description
      serviceOrderIds
      isDefault
      createdAt
      updatedAt
    }
  }
`;

const GET_SERVICE_ORDERS_BY_DEVICE_ID = gql`
  query GetServiceOrdersByDeviceId($deviceId: ID!, $workspaceId: ID!) {
    getServiceOrdersByDeviceId(deviceId: $deviceId) {
      id
      title
      order
      description
      isFinished
      executedAt
      createdAt
      updatedAt
      scheduledAt
      priority
      statusId
    }
    getServiceOrderStatusesByWorkspaceId(workspaceId: $workspaceId) {
      id
      description
    }
  }
`;

const GET_SERVICE_ORDER_STATUSES = gql`
  query GetServiceOrderStatuses($workspaceId: ID!) {
    getServiceOrderStatusesByWorkspaceId(workspaceId: $workspaceId) {
      id
      workspaceId
      description
      isDefault
    }
  }
`;

export default {
  GET_SERVICE_ORDERS,
  GET_SERVICE_ORDERS_BY_DEVICE_ID,
  GET_SERVICE_ORDER_STATUSES,
};
